import PageCommon from "./PageCommon.js";
import Pqp from "../3x1010/Pqp.js";
import Globals from "../Globals.js";


export default class PageJobs extends PageCommon {
  constructor() {
    super();
  }
  init($data) {
    super.init($data);
    this.showPreloader(false);
    Pqp.trace("PageJobs - Hello world");


    // dispaccio un evento globale
    try {
      this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
    } catch (error) {
      console.log(error);
    }

    this.doThings();
  }

  get isHomepage() {
    return false;
  }


  doThings() {
    jQuery(".js-select-taglist").select2({
      "maxHeight": 200,
      "enableCaseInsensitiveFiltering": true
    })


    jQuery(".js-select-filter").on("change", this.onFilterChanged.bind(this))
    jQuery(".js-reset-filters").on("click", this.resetFilters.bind(this))
    jQuery(".js-filtri-applicati").hide();


    // Controlla se deve settare dei filtri
    //sessionStorage.setItem("sica", "stica");
    let data = sessionStorage.getItem("filters");
    if (data) {
      data = JSON.parse(data);
      for (let x = 0; x < data.length; x++) {
        if (data[x] !== "-1") {
          this.applicaFiltro(x, data[x]);
        }
      }

    }
    this.onFilterChanged();

  }


  applicaFiltro(n, value) {
    const select = jQuery(".js-select-" + PageJobs.selectNames[n]);
    if (select.prop("multiple")) {
      const a = value.split(";")
      select.val(a)
      select.select2("destroy");
      select.select2();
    } else {
      select.val(value)
    }

  }

  onFilterChanged() {

    const names = PageJobs.selectNames;
    const tags = []
    const filters = []
    const a = jQuery(".js-select-filter");
    for (let x = 0; x < a.length; x++) {
      let values = jQuery(a[x]).val()
      if (Array.isArray(values)) {
        let tmp = ""
        for (let y = 0; y < values.length; y++) {
          tmp += values[y] + ";"
        }
        tmp = tmp.substr(0, tmp.length - 1);
        if (tmp.length === 0) {
          tmp = "-1";
        }
        filters.push(tmp)
        if (tmp !== "-1") {
          const opt = jQuery("option", jQuery(a[x]))
          for (let y = 0; y < opt.length; y++) {
            if (tmp.indexOf(jQuery(opt[y]).val()) >= 0) {
              tags.push({ select: jQuery(a[x]), id: jQuery(opt[y]).val(), multiple: true, text: jQuery(opt[y]).text() })
            }
          }
        }
      } else {
        if (values !== "-1") {
          tags.push({ select: jQuery(a[x]), id: values, multiple: false, text: jQuery("option:selected", jQuery(a[x])).text() });
        }
        filters.push(values)
      }
    }

    sessionStorage.setItem("filters", JSON.stringify(filters));

    const items = jQuery(".apply-item");
    const show = []
    const hide = []
    for (let x = 0; x < items.length; x++) {
      const item = jQuery(items[x]);
      let lShow = true;
      for (let y = 0; y < filters.length; y++) {
        if (filters[y] !== "-1") {
          if (("" + item.data(names[y])).indexOf(";") >= 0) {
            if (item.data(names[y]).indexOf(filters[y]) < 0) {
              lShow = false;
            }
          } else {
            if (filters[y] !== "" + item.data(names[y])) {
              lShow = false;
            }
          }
        }
      }
      if (lShow) {
        show.push(item)
      } else {
        hide.push(item)
      }
    }

    for (let x = 0; x < hide.length; x++) {
      hide[x].hide();
    }

    for (let x = 0; x < show.length; x++) {
      show[x].show();
    }

    if (show.length > 0) {
      jQuery(".js-no-results").hide();
    } else {
      jQuery(".js-no-results").show();
    }

    jQuery(".js-tag").remove();
    for (let x = 0; x < tags.length; x++) {
      const tag = jQuery("#template-tag").clone();
      tag.removeAttr("id");
      jQuery(".js-tag-text", tag).text(tags[x].text);
      jQuery(".js-tags").append(tag)
      tag.addClass("js-tag")
      tag.on("click", this.removeTag.bind(this, tags[x].select, tags[x].id, tags[x].multiple))
    }

    if (tags.length === 0) {
      jQuery(".js-filtri-applicati").slideUp(100);
    } else {
      jQuery(".js-filtri-applicati").slideDown();
    }

  }

  removeTag(select, opt, multiple, e) {
    if (multiple) {
      let values = select.val();
      let rem = [];
      for (let x = 0; x < values.length; x++) {
        if (values[x] !== opt) {
          rem.push(values[x])
        }
      }
      select.val(rem);
      select.select2("destroy")
      select.select2()

    } else {
      select.val("-1");
    }
    this.onFilterChanged();

  }

  resetFilters() {
    const names = PageJobs.selectNames;
    for (let x = 0; x < names.length; x++) {
      const select = jQuery(".js-select-" + names[x]);
      if (select.prop("multiple")) {
        select.val([]);
        select.select2("destroy")
        select.select2()
      } else {
        select.val("-1");
      }
    }
    this.onFilterChanged();
  }


}


PageJobs.selectNames = ["category", "location", "contract", "employmenttype", "taglist"];

